import Controller from '@ember/controller'
import { tracked } from '@glimmer/tracking'
import { service } from '@ember/service'
import type RouterService from '@ember/routing/router-service'

export enum ByStudentTabs {
  MyStudents = 'my-students',
  AllStudents = 'all-students',
}

export default class BookLibrarySharesByStudentController extends Controller {
  @service router!: RouterService

  queryParams = ['page', 'size', 'sort', 'tab']

  @tracked page = 1

  @tracked size = 10

  @tracked sort = 'first_name'

  @tracked tab = ByStudentTabs.MyStudents

  // We do this in the controller, rather than the route model, so that when it updates, it is tracked
  get expandedStudentId() {
    const studentId = this.router.currentRoute?.params?.student_id
    if (typeof studentId === 'string') return studentId
  }
}

declare module '@ember/controller' {
  interface Registry {
    'subscription-type/book-library/shares/index/by-student': BookLibrarySharesByStudentController
  }
}
